import { createActionCreator } from '@pressreader/appstore';

import { AUTHENTICATION_CORE_MODULE_NAME } from '../../constants';

// The same prefix `./common` uses: this action moved modules to keep it off the public barrel, and its TYPE
// string must not move with it.
const prefix = `${AUTHENTICATION_CORE_MODULE_NAME}/common/`;

/**
 * Internal to auth-core: reconcile the RTK Query caches to the identity the token now carries, for a transition
 * that produced no commit to hang the reconcile off. Raised by the mismatch recheck saga (`recheckIdentityMismatch`)
 * and consumed by the centralized reconcile listener, which is armed inside `@pressreader/appstore`'s
 * `identity.policy` at declaration time and matches this action through the predicate this lib injects at
 * bootstrap (`../identity.commit.ts`).
 *
 * An action rather than a direct call on purpose: the listener — and with it the policy/scope machinery it drives
 * — is LAZY, pulled in only by the first feature that declares an identity policy, and the recheck saga is eager.
 * When no such feature has armed it, nothing is dispatched into the void that matters: there is no cache to
 * reconcile, so an unheard dispatch is correct by construction, not a missed event.
 *
 * LIVES IN ITS OWN MODULE, deliberately not re-exported by `./index.ts`: that barrel re-exports `./common`
 * wholesale and the lib's public barrel re-exports the store, so declaring this next to the public actions would
 * publish it however loudly the docstring said "internal". Inside auth-core, import it from here by relative path.
 */
export const identityReconcileRequested = createActionCreator(`${prefix}identity_reconcile_requested`);
